import { appInsights } from 'utils/telemetry/app-insights';
import { safeTrackEventDD } from 'utils/datadog-logging';

export const safeTrackEvent = (
  name: string,
  properties?: Record<string, unknown>,
): void => {
  try {
    appInsights.trackEvent({ name }, properties);
    safeTrackEventDD(name, properties);
  } catch {
    safeTrackEventDD(`TrackEvent failed for event: ${name}`, properties);
  }
};
